const message = {
  intro_request_permission: 'Intro Link is Invalid',
  err_not_found: 'Intro Link is Invalid',
  required_parmas_not_found: 'Intro Link is Invalid',
  make_intro_done: 'You have already confirmed your interest!',
  make_intro_fail: 'You have already confirmed your interest!',
  make_intro_consent: 'You have already confirmed your interest!',
  make_intro_request_permission_rejected:
    'You have already declined the intro!',
  intro_declined: 'Thank you for replying',
};

export const getMessage = (id) => {
  return message[id];
};
